import React from 'react';
import {Link} from 'react-router-dom';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';


const TipListDivRow = ({tip, onDelete, onClone, intl}) => {
    return (
        <div>
            <div className="row" key={tip.id}>
                <div className="col-xs-12 col-sm-8">
                    <div className="col-12">#{tip.id}</div>
                    <div className="col-12"><strong>{intl.formatMessage(messages.heading)}:</strong></div>
                    <div className="col-12">{tip.title}</div>
                    <div className="col-12"><strong>{intl.formatMessage(messages.description)}:</strong></div>
                    <div className="col-12">{tip.description}</div>
                </div>
                <div className="col-sx-12 col-sm-4 text-right">
                    <div className="btn-group text-right mt-1">
                        <Link to={'/tips/redigere/'+tip.id}
                              className="btn btn-secondary waves-effect list-action mt-2"
                        >
                            <i className="fa fa-pencil"/> {intl.formatMessage(messages.listDropDownButtonEdit)}
                        </Link>
                        <button type="button" className="btn btn-secondary clickable dropdown-toggle mt-2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span className="sr-only">{intl.formatMessage(messages.actions)}</span>
                        </button>
                        <div className="dropdown-menu">
                            {/*<button*/}
                                {/*title="Kopier"*/}
                                {/*type="button"*/}
                                {/*className="dropdown-item clickable"*/}
                                {/*onClick={() => onClone(tip.id)}*/}
                            {/*>*/}
                                {/*<i className="fa fa-clone"/> Kopier*/}
                            {/*</button>*/}
                            {/*<div className="dropdown-divider"></div>*/}
                            <button type="button"
                                    className="dropdown-item clickable"
                                    onClick={() => onDelete(tip.id)}
                            >
                                <i className="fa fa-trash-o"/> {intl.formatMessage(messages.listDropDownButtonDelete)}
                            </button>
                        </div>
                    </div>
                </div>

            </div>
            <hr />
        </div>
    );
};

export default injectIntl(TipListDivRow);



// WEBPACK FOOTER //
// ./web/src/components/tips/TipListDivRow.jsx